module.exports = __webpack_public_path__ + "img/layout_grid.ec9fd346.webp";